import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { loadEmployeeByIdAct, findEmployeeAct} from "./employee.actions";
import { catchError, exhaustMap, map, of } from "rxjs";
import { EmployeeListService } from "../../services/employee-list.service";

@Injectable()
export class EmployeeEffects {

    private actions$ = inject(Actions);
    //private router = inject(Router);
    private employeeService = inject(EmployeeListService);

    /*loadEmployeeEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(loadEmployeeAct),
            exhaustMap(action => this.employeeService.findAllPageableEmployee(action.page, action.pageSize)
                .pipe(
                    map(pageable => {
                        const employees = pageable.list as Employee[];
                        delete pageable.list;
                        const paginator = pageable;

                        return findAllPageableEmployeeAct({ employees, paginator });
                    }),
                    catchError((error) => of(error))
                )
            )
        )
    );*/

    findEmployeeEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(findEmployeeAct),
            exhaustMap(action => this.employeeService.findEmployeeById(action.id)
        .pipe(
            map(employee => loadEmployeeByIdAct({ employee })),
            catchError(error => of(error))
        ))
        )
    );
}